import { AuthService } from './../services/auth.service';

import { HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent } from '@angular/common/http';

import { HttpErrorResponse } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { switchMap, catchError, filter, take, finalize, tap } from 'rxjs/operators';

import { RefreshTokenApi } from '../api/oauth.api';
import { Store } from '@ngxs/store';
import { AuthState } from '../state/auth.state';
import { environment } from '@env/environment';
import { Logout, UpdateTokens } from '../actions/auth.action';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private authService: AuthService, private store: Store ) {
  }


  private isAccessTokenInvalid( response: HttpErrorResponse ) {
    return ( response.error && response.error.message && response.error.message.code === 'OAUTH_TOKEN_INVALID' );

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    if ( environment.useMock ) {
      return next.handle( request );
    }
    if (  request.url.includes( 'oauth' ) || request.url.includes( '/iq/api/config/' ) || request.url.includes( 'en.json' ) ) {
        return next.handle( request );
    }
    const currentAccessToken = this.store.selectSnapshot( AuthState.token );
    return next.handle(this.addTokenToRequest(request, currentAccessToken ) )
      .pipe(
        catchError(err => {
          const handledError: boolean = err instanceof HttpErrorResponse && this.isAccessTokenInvalid( <HttpErrorResponse>err  );
          if ( handledError ) {
            switch ((<HttpErrorResponse>err).status) {
              case 401:
                return this.handle401Error(request, next);
            }
          } else {
            return throwError( err );
          }
        }
      )
    );
  }
  private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({ setHeaders: { Authorization: `Bearer ${token}`}});
  }
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;
      this.tokenSubject.next(null);
      const refreshToken = this.store.selectSnapshot( AuthState.refreshToken );
      return this.authService.refreshAccessToken( refreshToken )
        .pipe(
          tap( ( response: RefreshTokenApi.Response ) =>
            this.store.dispatch( new UpdateTokens( { accessToken: response.access_token, refreshToken: response.refresh_token } )  )
         )
          ,
          switchMap((response: RefreshTokenApi.Response) => {
             if ( response ) {
              this.tokenSubject.next(response.access_token);
              return next.handle(this.addTokenToRequest(request, response.access_token));
            }
            const currentAccessToken = this.store.selectSnapshot( AuthState.token );
            return this.store.dispatch( new Logout( currentAccessToken ) );
          })
          ,
          catchError( () => this.store.dispatch( new Logout( this.store.selectSnapshot( AuthState.token ) ) )  )
          ,
          finalize(() => {
            this.isRefreshingToken = false;
          })
        );
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject
        .pipe(filter(token => token != null),
          take(1),
          switchMap(token => {
          return next.handle(this.addTokenToRequest(request, token));
        }));
    }
  }
}


